<template>
  <img src="~/assets/icon/icon-exit.svg" />
</template>
